import React from "react";
import cx from "classnames";
import { CheckMarkSvg } from "./checkMark.styles";

export const CheckMark = ({height = 60, strokeWidth, checked, className}) => {
  
  return (
    <CheckMarkSvg className={cx(className, {checked})} strokeWidth={strokeWidth} width={height} height={height} viewBox="0 0 184 184" xmlns="http://www.w3.org/2000/svg">
      <g className="circles">
        <circle cx="92" cy="92" r="70" stroke="#CCC" />
        <circle className="color-circle" cx="92" cy="92" r="70" />
      </g>
      <path d="M59.5 94.5L85 120L141.5 63.5" />
    </CheckMarkSvg>
  );
};